export async function markdownFetch(path: string) {
  return await fetch(path).then((response) => response.text())
}